import type { ComponentProps } from 'react';

import { Badge, BADGE_STATUS_DOT_CLASS_NAME } from '@/components/ui/badge';

import { cn } from '@/lib/utils';

export const StatusBadge = (props: ComponentProps<typeof Badge>) => {
  const { className, ...badgeProps } = props;

  return (
    <Badge
      className={cn(BADGE_STATUS_DOT_CLASS_NAME, className)}
      {...badgeProps}
    />
  );
};
